import { render, staticRenderFns } from "./LegendCategory.vue?vue&type=template&id=74651c3a&scoped=true"
import script from "./LegendCategory.vue?vue&type=script&lang=js"
export * from "./LegendCategory.vue?vue&type=script&lang=js"
import style0 from "./LegendCategory.vue?vue&type=style&index=0&id=74651c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74651c3a",
  null
  
)

export default component.exports